export const BRAND = {
  name: "JEET ADVISORY SERVICES",
  tagline: "The right capital. The right structure. The right source.",
};

export const CONTACT = {
  email: "jeetadvisoryservices@gmail.com",
  phoneDisplay: "+91 97022 63336",
  whatsapp:
    "https://wa.me/919702263336?text=" +
    encodeURIComponent(
      "Hello Sharanjit, I would like to discuss a capital requirement."
    ),
  linkedin:
    "https://www.linkedin.com/in/sharanjit-singh-panesar-9b8a0b17",
  linkedinName: "Sharanjit Singh Panesar",
};

export const NAV_LINKS = [
  { id: "home", label: "Home" },
  { id: "about", label: "About" },
  { id: "capabilities", label: "Capabilities" },
  { id: "capital-solutions", label: "Capital Solutions" },
  { id: "how-we-work", label: "How We Work" },
  { id: "insights", label: "Insights" },
  { id: "contact", label: "Contact" },
];

export const TEAM = [
  {
    name: "Sharanjit Singh Panesar",
    designation: "Founder & Capital Advisor",
    photo: "/founder.webp",
    bio: "Sharanjit works directly with promoters, CFOs and business owners to evaluate financing requirements, identify the appropriate capital structure and coordinate transactions with relevant banks, NBFCs, private-credit funds and institutional investors.",
    linkedin:
      "https://www.linkedin.com/in/sharanjit-singh-panesar-9b8a0b17",
  },
];

export const APPROACH = [
  { key: "understand", label: "Understand" },
  { key: "structure", label: "Structure" },
  { key: "match", label: "Match" },
  { key: "execute", label: "Execute" },
];

export const CAPABILITIES = [
  {
    title: "Corporate Debt Advisory",
    description:
      "Debt solutions tailored around business cash flows, leverage and repayment capacity.",
  },
  {
    title: "Structured Finance",
    description:
      "Structured debt and customised financing solutions for situations that do not fit conventional lending.",
  },
  {
    title: "Private Credit",
    description:
      "Access to private-credit and alternative capital providers for appropriate mid-market opportunities.",
  },
  {
    title: "Project Finance",
    description:
      "Financing solutions for projects requiring longer tenors, construction periods and structured repayment.",
  },
  {
    title: "Working Capital",
    description:
      "Receivables, purchase orders, trade finance and other structured working-capital solutions.",
  },
  {
    title: "Capital Raising",
    description:
      "Helping businesses identify appropriate debt, structured capital and equity-oriented funding options.",
  },
];

export const CAPITAL_STACK = [
  {
    name: "Bank Debt",
    description:
      "Senior secured lending from banks for established cash flows and conventional collateral.",
  },
  {
    name: "NBFC",
    description:
      "Non-banking lenders offering greater flexibility on structure, tenor and security.",
  },
  {
    name: "Private Credit",
    description:
      "Alternative capital providers for mid-market situations requiring customised terms.",
  },
  {
    name: "Structured Credit",
    description:
      "Instruments designed around the specific risk and cash-flow profile of a transaction.",
  },
  {
    name: "Special Situations",
    description:
      "Capital for complex, time-sensitive or transitional situations.",
  },
  {
    name: "Equity Capital",
    description:
      "Ownership-oriented capital for growth, deleveraging or strategic transactions.",
  },
];

export const PROCESS = [
  {
    step: "01",
    title: "Understand",
    description:
      "Understand the business, funding requirement, financial profile, collateral, existing debt and intended use of funds.",
  },
  {
    step: "02",
    title: "Structure",
    description:
      "Evaluate the appropriate financing route, structure, tenor, security and capital source.",
  },
  {
    step: "03",
    title: "Match",
    description:
      "Identify relevant banks, NBFCs, private-credit funds, structured-credit investors and other capital providers.",
  },
  {
    step: "04",
    title: "Execute",
    description:
      "Coordinate documentation, discussions, due diligence and transaction execution with the relevant parties.",
  },
];

export const CLIENT_TYPES = [
  "Established businesses",
  "Promoters",
  "Mid-market companies",
  "Growth-stage businesses",
  "Real estate and hospitality projects",
  "Manufacturing businesses",
  "Infrastructure and project businesses",
  "Companies seeking refinancing",
  "Businesses requiring structured capital",
];

export const DIFFERENTIATORS = [
  {
    title: "Capital-source agnostic",
    description:
      "We evaluate the requirement before determining where it should be placed.",
  },
  {
    title: "Structure before placement",
    description:
      "We focus on understanding the transaction and structuring the requirement rather than simply circulating it to lenders.",
  },
  {
    title: "Access to diverse capital",
    description:
      "We work across traditional and alternative sources of capital.",
  },
  {
    title: "Complex situations welcome",
    description:
      "We can evaluate requirements that may not fit conventional lending products.",
  },
  {
    title: "Relationship-driven execution",
    description:
      "Capital transactions depend on credibility, preparation and communication. We coordinate closely with all stakeholders throughout the process.",
  },
];

export const FEATURED = [
  {
    amount: "₹60 Cr",
    title: "Corporate Refinancing & Capex",
    meta: ["Manufacturing", "Secured", "36-month requirement"],
  },
  {
    amount: "₹80 Cr",
    title: "Hospitality Project Finance",
    meta: ["Hospitality", "Project Finance", "Long-tenor requirement"],
  },
  {
    amount: "₹20–100 Cr",
    title: "Private Credit Opportunities",
    meta: ["Mid-market businesses", "Secured structured credit"],
  },
];

export const INSIGHTS = [
  {
    title: "Understanding the Capital Stack",
    slug: "understanding-the-capital-stack",
    readTime: "6 min read",
    excerpt:
      "How senior debt, structured credit and equity interact — and why position in the stack determines cost, control and flexibility.",
  },
  {
    title: "Bank Debt vs NBFC vs Private Credit",
    excerpt:
      "A practical comparison of pricing, speed, covenants and structural flexibility across India's primary debt channels.",
  },
  {
    title: "When Structured Credit Makes Sense",
    excerpt:
      "Situations where conventional lending products fall short, and how structured instruments bridge the gap.",
  },
  {
    title: "Project Finance: What Lenders Evaluate",
    excerpt:
      "The fundamentals capital providers assess before committing long-tenor project capital.",
  },
];

export const HERO_STATS = [
  { value: "₹500 Cr+", label: "Capital Syndicated" },
  { value: "40+", label: "Lending Partners" },
  { value: "12+", label: "Years Advising" },
];

export const MARQUEE_ITEMS = [
  "Capital Advisory",
  "Structured Finance",
  "Private Credit",
  "Project Finance",
  "Working Capital",
  "Debt Advisory",
  "Capital Raising",
  "Corporate Finance",
];

export const FUNDING_RANGES = [
  "₹5 – 25 Cr",
  "₹25 – 100 Cr",
  "₹100 – 500 Cr",
  "₹500 Cr +",
  "To be determined",
];

export const FUNDING_PURPOSES = [
  "Growth / Expansion",
  "Refinancing",
  "Working Capital",
  "Project Finance",
  "Structured / Special Situations",
  "Other",
];

export const CONTACT_METHODS = ["Phone", "Email", "WhatsApp"];
